import { render, staticRenderFns } from "./leadDisqualified.vue?vue&type=template&id=64f2ba0e&scoped=true"
import script from "./leadDisqualified.vue?vue&type=script&lang=js"
export * from "./leadDisqualified.vue?vue&type=script&lang=js"
import style0 from "./leadDisqualified.vue?vue&type=style&index=0&id=64f2ba0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f2ba0e",
  null
  
)

export default component.exports